var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.addClasses},[(_vm.item.hasResult && _vm.item.result.loginLabel)?_c('span',[_vm._v(_vm._s(_vm.getTranslation(_vm.item.result.loginLabel)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }